<template>
<widget title="KPIs">
	<div class="kpi-row">
		<div class="kpi-box kpi-box-full">
			<span class="kpi-box-label">Billed to Date ($)</span>
			<span class="kpi-box-value">{{ '$ ' + totalBilledToDateValue.toCurrency() }}</span>
		</div>
		<div class="kpi-box">
			<span class="kpi-box-label">% Complete</span>
			<span class="kpi-box-value">{{ totalBilledToDatePercent.toFixed(1) + '%' }}</span>
		</div>
		<div class="kpi-box">
			<span class="kpi-box-label">Labour Progress</span>
			<span class="kpi-box-value">{{ labourPercentConsumed.toFixed(1) + '%' }}</span>
		</div>
		<div class="kpi-box">
			<span class="kpi-box-label">% Total Cost</span>
			<span class="kpi-box-value">{{ totalCostPercent.toFixed(1) + '%' }}</span>
		</div>
		<div class="kpi-box kpi-box-full">
			<span class="kpi-box-label">Value Remaining to Invoice</span>
			<span class="kpi-box-value">{{ '$ ' + valueRemainingToInvoice.toCurrency() }}</span>
		</div>
	</div>
</widget>
</template>
<script>

import Widget from "@/components/Widget"

import InvoiceMixins from "@/mixins/InvoiceMixins.js"
import ProjectBidMixins from "@/mixins/ProjectBidMixins.js"

export default {
	name: "ProjectKpiWidget",
	components: {
		Widget
	},
	mixins: [InvoiceMixins,ProjectBidMixins],
	props: [],
	data() {
		return {
			timeLogs: [],
			expenseReportValues: null,
			budgetedTotalCostFromBid: 0
		}
	},
	watch: {
		'$store.project'() {
			this.fetchData()
		}
	},
	computed: {
		invoices() {
			return this.$store.invoices.filter(inv => inv.is_finalized == 1)
		},
		totalBilledToDateValue() {
			return this.invoices.reduce((acc,item) => acc + +item.pretax_total,0)
		},
		totalBilledToDatePercent() {
			if (this.totalProjectValue == 0)
				return 0
			return this.totalBilledToDateValue / this.totalProjectValue * 100
		},
		originalProjectValue() {
			return this.mutateTasks(this.tasks).reduce((acc,task) => {
				let total = 0

				if ("totalValue" in task) {
					let totalValue = task.totalValue.replaceAll(",","")
					total = +totalValue
				}

				total = total.round(2)

				return acc + total
			},0)
		},
		totalChangeOrderValue() {
			return this.mutateChangeOrders(this.changeOrders).reduce((acc, co) => {

				let total = 0
				if ("totalValue" in co) {
					let totalValue = co.totalValue.replaceAll(",","")
					total = +totalValue
				}

				total = total.round(2)

				return acc + total
			},0)
		},
		totalLabourToDateValue() {
			return this.timeLogs.reduce((acc,item) => acc + +item.calculated_cost,0)
		},
		totalProjectLabourBudget() {
			let bidLabour = 0

			if (this.bid && this.bid.id && this.bidComponentsNested && this.bidComponentsNested.length > 0) {
				let labourRecords = this.flattenedRecordsFromNested("labour")

				bidLabour = this.totalRecordsValue(labourRecords)
			}
			let changeOrderLabour = (this.changeOrders || []).reduce((acc, co) => {
				let coLabour = 0
				let objects = co.JobChangeOrderObject || co.JobChangeQuoteObject || []
				objects.filter(obj => obj.type === "Labour").forEach(obj => {
					let parsed = {}
					try {
						parsed = JSON.parse(obj.field_values_json || "{}")
					} catch (e) {}
					let lineTotal = (+(parsed.hrs) || 0) * (+(parsed.rate) || 0) * (+(parsed.crew) || 1)
					coLabour += lineTotal
				})
				let coQty = +(co.qty) || 1
				return acc + coLabour * coQty
			}, 0)

			return (bidLabour + changeOrderLabour).round(2)
		},
		totalProjectValue() {
			return this.originalProjectValue + this.totalChangeOrderValue
		},
		labourPercentConsumed() {
			return this.totalProjectLabourBudget > 0 ? this.totalLabourToDateValue / this.totalProjectLabourBudget * 100 : 0
		},
		totalExpenseToDate() {
			if (!this.expenseReportValues || this.expenseReportValues.subtotal_sum == null)
				return 0
			return +this.expenseReportValues.subtotal_sum
		},
		totalCostToDate() {
			return this.totalExpenseToDate + this.totalLabourToDateValue
		},
		totalCostPercent() {
			if (!this.budgetedTotalCostFromBid || this.budgetedTotalCostFromBid <= 0)
				return 0
			return this.totalCostToDate / this.budgetedTotalCostFromBid * 100
		},
		valueRemainingToInvoice() {
			return Math.max(0, this.totalProjectValue - this.totalBilledToDateValue)
		}
	},
	methods: {
		fetchTimeLogs() {
			let vm = this 

			let params = {
				filters: [
					["job_id",this.$store.project.id],
					["calculated_cost >",0]
				]
			}

			this.getJSON("TimeLog/get",params).then(response => {
				if (response.success)
					vm.timeLogs = response.data
			})
		},
		fetchData() {
			let vm = this

			vm.expenseReportValues = null
			vm.budgetedTotalCostFromBid = 0

			this.fetchProjectInvoices(false,["JobInvoiceTask"],["id","slug","pretax_total","grand_total","is_finalized"])
			this.fetchProjectTasks()
			this.fetchProjectChangeOrders(false, ["JobChangeOrderObject"])
			this.fetchTimeLogs()
			this.getJSON("Expense/report", { filters: [["job_id", this.$store.project.id]] }).then(response => {
				if (response.success && response.data) {
					vm.expenseReportValues = {}
					Object.keys(response.data).forEach(key => {
						vm.expenseReportValues[key] = +response.data[key]
					})
				}
			})
			this.fetchActiveBid({projectId: this.$store.project.id}).then(response => {
				if (response) {
					vm.fetchBid(response.slug).then((bidResponse) => {
						if (vm.bid && vm.bid.id) {
							vm.fetchAllComponents(vm.bid.id, ["JobBidComponentObject"]).then(response => {
								vm.budgetedTotalCostFromBid = vm.computeBudgetedCostFromFlattened()
							})
						}
					})
				}
			})
		}
	},
	created() {

		if (this.$store.project && "id" in this.$store.project)
			this.fetchData()
	}
}
</script>

<style scoped>
.kpi-row {
	display: flex;
	gap: 1rem;
	justify-content: space-between;
	align-items: stretch;
	width: 100%;
	flex-wrap: wrap;
}

.kpi-box {
	flex: 1;
	min-width: 0;
	aspect-ratio: 1;
	max-height: 200px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 1.25rem;
	background: var(--button-secondary-faded);
	border: 3px solid var(--button-secondary);
	border-radius: 8px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
	transition: box-shadow 0.2s ease, border-color 0.2s ease;
}

.kpi-box:hover {
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
	border-color: var(--brand-primary-color);
}

.kpi-box-label {
	display: block;
	font-size: 0.95rem;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.04em;
	color: var(--text-dark, #333);
	text-align: center;
	margin-bottom: 0.75rem;
	line-height: 1.2;
}

.kpi-box-value {
	display: block;
	font-size: 1.75rem;
	font-weight: 700;
	color: var(--brand-primary-color, #2c3e50);
	text-align: center;
	line-height: 1.2;
	word-break: break-word;
}

@media (max-width: 992px) {
	.kpi-row {
		gap: 0.75rem;
	}
	.kpi-box-label {
		font-size: 0.8rem;
	}
	.kpi-box-value {
		font-size: 1.35rem;
	}
}

@media (max-width: 800px) {
	.kpi-row {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
	}
	.kpi-box {
		aspect-ratio: auto;
		min-height: 88px;
	}
}

@media (max-width: 500px) {
	.kpi-box-full {
		grid-column: 1 / -1;
		width: 100%;
	}
}
</style>